module.exports = __webpack_public_path__ + "static/media/DGR.0d418566.png";